{
  "versions": [
    {
      "version": "1.0.4",
      "date": "31.10.2025",
      "changes": [
        "Fix: Headline-Helfer - Headline bold darstellen statt Kicker",
        "Fix: URLs brechen jetzt um bei schmalen Screens"
      ]
    },
    {
      "version": "1.0.3",
      "date": "31.10.2025",
      "changes": [
        "SecondReading Ergebnis Darstellung zeigt jetzt auch Fakten und Quellen",
        "Sperrvermerk Ergebnis Darstellung zeigt jetzt auch Score, Referenz und Zusammenfassung",
        "Anzeige von Infobox wenn keine Sperrvermerke gefunden wurden",
        "Versionsnummer der Ergebnisse wird jetzt nur angezeigt wenn Historie existiert",
        "Design der generierten Feature Ergebnisse verbessert",
        "Collection Section fuer Welt entfernen und FactChecker in Generate integriert",
        "Redesign: Header (entfernt) und Sidepanel Menu (angepasst)",
        "Redesign: Verlauf",
        "Neu: Expertenkasten Endpunkt implementiert",
        "Neu: Crawler fuer Business Insider US implementiert",
        "Neu: Tenant spezifische Benennung der Feature Buttons moeglich",
        "Neu: Spelling&Grammar Endpunkt fuer Welt",
        "Neu: Crawler Restriction - Einschränkung fuer Bild",
        "Neu: Agenturtext umschreiben Endpunkt fuer Welt",
        "Neu: SecondReading & Expertenkasten koennen jetzt zusätzliche Daten mitsenden"
      ]
    },
    {
      "version": "1.0.2",
      "date": "15.08.2025",
      "changes": [
        "Fix: ‚Source‘ Link von Konflikten im Darkmode nicht sichtbar",
        "Fix: ‚Google Search‘ in „Brave Search’ umbenannt in Streaming Events",
        "Verbessert: Menu (kein ‚open state‘ mehr, verbessert responsives Verhalten)",
        "Verbessert: Referenzartikel löschen, setzt die komplette Kollektion zurück",
        "Neu: Feature Evergreen (Welt) in Generieren Bereich",
        "Neu: Feature DigitalHome (Welt) in Generieren Bereich",
        "Neu: Info Bereich - listet vorhandene Crawler und Features / Filterfunktion",
        "Neu: Crawler fuer bild.de und welt.de",
        "Neu: Bereichsheader mit Beschreibungen"
      ]
    }
  ]
}
